import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HomePageMainSection from '../HomePageMainSection/HomePageMainSection';
import WhyWhatsapp from '../WhyWhatsapp/WhyWhatsapp';
import OurFeatures from '../OurFeatures/OurFeatures';
import HowWorks from '../HowWorks/HowWorks';
import WorkIntegrations from '../WorkIntegrations/WorkIntegrations';
import QuestionsAnswers from '../QuestionsAnswers/QuestionsAnswers';
import Examples from '../Examples/Examples';
import IntroductionForm from '../IntroductionForm/IntroductionForm';
import SignUpModal from './SignUpModal';
import './HomePageElements.css';

const HomePageElements = () => {
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(true); // Show modal on page load

  const closeModal = () => {
    setIsModalOpen(false); // Close modal
  };

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          const yOffset = -80; 
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100); 
    }
  }, [location.state]);

  return (
    <main className="HomePageElements">
      <SignUpModal isOpen={isModalOpen} closeModal={closeModal} /> {/* Modal Component */}
      <section id="HomePageMainSection">
        <HomePageMainSection />
      </section>
      <section id="why-whatsapp">
        <WhyWhatsapp />
      </section>
      <section id="our-features">
        <OurFeatures />
      </section>
      {/* <section id="Examples">
        <Examples />
      </section> */}
      <section id="WorkIntegrations">
        <WorkIntegrations />
      </section>
      <section id="HowWorks">
        <HowWorks />
      </section>
      <section id="IntroductionForm">
        <IntroductionForm />
      </section>
      <section id="QuestionsAnswers">
        <QuestionsAnswers />
      </section>
    </main>
  );
};

export default HomePageElements;
